<template>
    <b-modal id="justificarMassaModal" title="Justificar Gatilhos" hide-footer size="md">
        <p class="mb-3">
            Você selecionou <strong>{{ selectedTriggersCount }}</strong> ocorrência(s)
        </p>

        <div class="mb-3">
            <label for="justifyMassaText" class="font-weight-bold">Motivo:</label>
            <textarea
                id="justifyMassaText"
                class="form-control mt-2"
                v-model="justifyText"
                rows="4"
                placeholder="Digite o motivo da justificativa">
            </textarea>
        </div>

        <div class="d-flex justify-content-between">
            <b-button variant="secondary" @click="cancelar">
                Não
            </b-button>
            <b-button class ="orange-btn" @click="confirmar">
                Sim
            </b-button>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: "JustificarMassaModal",
    props: {
        selectedTriggersCount: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            justifyText: ""
        };
    },
    methods: {
        cancelar() {
            this.justifyText = "";
            this.$bvModal.hide('justificarMassaModal');
            this.$emit('cancelar');
        },
        confirmar() {
            this.$emit('confirmar', this.justifyText);
            this.justifyText = "";
        }
    }
};
</script>

<style>
.orange-btn{
    background-color: #ff5f00;
    border-color: #ff5f00;
    color: #fff;
}
</style>
